module.exports = __webpack_public_path__ + "img/policlinika.2cb7ecaf.png";